import { CSSObject } from '@emotion/react'
import {
  AlignItems,
  Box,
  Display,
  Image,
  JustifyContent,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import React from 'react'

export type LargeImageWithTextProps = {
  children: React.ReactNode
  desktopSrc: string
  mobileSrc: string
  altText: string
}

const Container = withCitrusTheme(Box, (theme) => ({
  ...(theme.responsiveStyle(['column-reverse', null, null, 'row'], ['flexDirection']) as CSSObject),
  margin: '0 auto',
}))

export function LargeImageWithText({
  children,
  desktopSrc,
  mobileSrc,
  altText,
}: LargeImageWithTextProps) {
  return (
    <Container
      display={Display.Flex}
      alignItems={AlignItems.FlexStart}
      justifyContent={JustifyContent.SpaceEvenly}
      paddingH={8}
      paddingV={16}
      gap={[8, null, null, 16]}
      maxWidth="1200px"
    >
      <Box width={['100%', null, null, '50%']} style={{ borderRadius: '8px', overflow: 'hidden' }}>
        <picture>
          <source srcSet={desktopSrc} media="(min-width: 1024px)" />
          <source srcSet={mobileSrc} />
          <Image fit="cover" alt={altText} src={mobileSrc} />
        </picture>
      </Box>

      <Box width={[null, null, null, '50%']} paddingRight={4}>
        {children}
      </Box>
    </Container>
  )
}
